import clsx from 'clsx';
import React from 'react';

import { Theme } from '@interfaces/global';

import Input, { InputProps } from '../Input';

type EmailInputProps = Omit<InputProps, 'type'> & {
  isPro?: boolean;
  isRight?: boolean;
  theme: Theme;
};

const EmailInput = ({ inputClassName, isPro, isRight, theme, ...rest }: EmailInputProps) => {
  return (
    <div className={clsx('flex w-full flex-col', { 'items-end': isRight })}>
      <Input
        type="email"
        inputClassName={clsx(
          inputClassName,
          'w-[240px] rounded-none border-solid p-8 font-suisse-intl text-button-sm text-primary-black placeholder-grayscale-gray focus:outline-none',
          {
            'border-primary-magenta focus-visible:border-primary-pink': !isPro,
            'border-pro-gold focus-visible:border-grayscale-beige': isPro,
            'bg-grayscale-charcoal text-white placeholder:text-white border-primary-magenta':
              theme === Theme.Dark,
          }
        )}
        {...rest}
      />
    </div>
  );
};

export default EmailInput;
